module.exports = __webpack_public_path__ + "img/carousel-photo01.6c22a38e.jpg";